const { View } = require('@react-pdf/renderer')

const PDFRow = ({ children, height, style, width, marginLeft }) => (
  <View
    style={{
      width,
      marginLeft,
      display: 'flex',
      flexDirection: 'row',
      height,
      border: '0.8px solid black',
      ...style,
    }}
  >
    {children}
  </View>
)

export default PDFRow
